import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatus } from '@common/enums';

@Pipe({
  name: 'statusType',
  pure: true
})
export class TaskStatusTypePipe implements PipeTransform {
  private readonly map = new Map<TaskStatus, string>([
    [TaskStatus.Pending, 'muted'],
    [TaskStatus.Running, 'primary'],
    [TaskStatus.Finished, 'success'],
    [TaskStatus.Failed, 'danger'],
    [TaskStatus.Paused, 'muted'],
    [TaskStatus.LimitExceeded, 'warning'],
    [TaskStatus.Cancelled, 'danger']
  ]);

  transform(status: TaskStatus): any {
    const classes: string[] = [];

    if (status) {
      classes.push(this.map.get(status));
    }

    return classes.join(' ');
  }
}
